export interface IMobileAppServicesTheme {
  bgColor?: string;
  textColor?: string;
  borderColor?: string;
  iconFillcolor?: string;
  showBlur?: boolean;
}

export const themes: Record<'dark' | 'light', IMobileAppServicesTheme> = {
  dark: {
    bgColor: 'bg-graphite',
    textColor: 'text-brown',
    borderColor: 'border-brown',
    iconFillcolor: 'fill-brown',
    showBlur: true
  },
  light: {
    bgColor: 'bg-transparent',
    textColor: 'text-graphite',
    borderColor: 'border-sand-light',
    iconFillcolor: 'fill-sand-light',
    showBlur: false
  }
};
